module.exports = __webpack_public_path__ + "img/9788993094770.3662acd7.jpg";